import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
import { Card, Button, Typography } from "antd";
import { Icon } from "ui/Icon";
import { cleanExperiencesByGuide } from "store/experiences";
import styles from "./ExperienceCard.module.css"
import { routes } from "router";

const { Title, Text } = Typography;

const EmbeddedExperienceCard = ({
    image,
    title,
    location,
    time,
    people,
    price,
    experienceId
}) => {
    const { uuid } = useParams();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const formattedStart = time?.start ? moment(time?.start, "HH:mm")?.format("hh:mm A") : "-";
    const formattedEnd = time?.end ? moment(time.end, "HH:mm")?.format("hh:mm A") : "-";

    return (
        <Card
            hoverable
            cover={<img src={image} alt={title} className={styles.coverImage} />}
            className={styles.card}
        >
            <Title level={5} className={styles.title}>
                {title}
            </Title>
            <div className={styles.infoRow}>
                <Icon type="feather" name="MapPin" width={16} height={16} />
                <Text type="secondary" style={{ fontSize: 12 }} className={styles.locationText}>
                    {location}
                </Text>
            </div>
            <div className={styles.infoRow}>
                <Icon type="feather" name="Clock" width={16} height={16} />
                <Text type="secondary" style={{ fontSize: 12 }}>{`${formattedStart} - ${formattedEnd}`}</Text>
            </div>
            <div className={styles.personRow}>
                <Icon type="feather" name="User" width={16} height={16} />
                <div className={styles.personDetails}>
                    <Text type="secondary" style={{ fontSize: 12 }}>{people} people</Text>
                    <div className={styles.priceBlock}>
                        <Text strong className={styles.price}>${price}</Text>
                        <Text type="secondary" style={{ fontSize: 12 }}>/ 1 person</Text>
                    </div>
                </div>
            </div>
            <Button type="primary" block className={styles.button} onClick={() => {
                navigate(routes.embeddedExperienceDetail({ uuid: uuid, id: experienceId }))
                dispatch(cleanExperiencesByGuide())
            }}>
                Book Now
            </Button>
        </Card>
    );
};

export default EmbeddedExperienceCard;

EmbeddedExperienceCard.propTypes = {
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    time: PropTypes.shape({
        start: PropTypes.string,
        end: PropTypes.string
    }),
    people: PropTypes.number,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    experienceId: PropTypes.string.isRequired
};
